import React, { useEffect, useState } from "react";
import { ref, get } from "firebase/database";
import { db } from "../services/firebase";
import { useNavigate } from "react-router-dom";

export default function StudentResultPage() {
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadResult = async () => {
      try {
        const activeTest = JSON.parse(localStorage.getItem("activeTest") || "{}");
        const studentSession = JSON.parse(localStorage.getItem("studentSession") || "{}");
        const specialStudentId = activeTest.specialStudentId || studentSession.specialStudentId;

        if (!specialStudentId) {
          navigate("/student-login");
          return;
        }

        const resultRef = ref(db, `studentResults/${specialStudentId}`);
        const snap = await get(resultRef);

        if (snap.exists()) {
          setResult(snap.val());
        } else {
          setResult({ message: "Result not available yet." });
        }
      } catch (err) {
        console.error("Error loading result:", err);
        setResult({ error: "Failed to load result" });
      } finally {
        setLoading(false);
      }
    };

    loadResult();
  }, [navigate]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "60px" }}>
        <h2>Loading your result...</h2>
      </div>
    );
  }

  if (!result) {
    return (
      <div style={{ textAlign: "center", padding: "60px" }}>
        <h2>No result found</h2>
        <button onClick={() => navigate("/student-login")}>Back to Login</button>
      </div>
    );
  }

  if (result.error || result.message) {
    return (
      <div style={{ textAlign: "center", padding: "60px" }}>
        <h2>{result.error || result.message}</h2>
        <button onClick={() => navigate("/student-login")}>Back to Login</button>
      </div>
    );
  }

  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "0 auto" }}>
      <h2 style={{ textAlign: "center", marginBottom: "30px" }}>📊 Your Test Result</h2>
      
      <div style={{ background: "#f5f5f5", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}>
        <h3>{result.quizTitle || "Test Result"}</h3>
        <p><strong>Test Type:</strong> {result.testType || "N/A"}</p>
        <p><strong>Topic:</strong> {result.topic || "N/A"}</p>
        <p><strong>Submitted At:</strong> {new Date(result.submittedAt).toLocaleString()}</p>
      </div>

      <div style={{ background: "#e8f5e9", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}>
        <h3>Score Summary</h3>
        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
          Score: {result.score || 0} / {result.totalMarks || 0}
        </p>
        <p>Accuracy: {result.accuracy || "0.00"}%</p>
        <p>Time Taken: {result.timeTaken || "N/A"}</p>
      </div>

      {result.studentDetails && (
        <div style={{ background: "#fff3e0", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}>
          <h3>Your Details</h3>
          <p><strong>Name:</strong> {result.studentDetails.name || "N/A"}</p>
          <p><strong>Phone:</strong> {result.studentDetails.phone || "N/A"}</p>
          {result.studentDetails.rollNo && <p><strong>Roll No:</strong> {result.studentDetails.rollNo}</p>}
          {result.studentDetails.universityRoll && <p><strong>University Roll:</strong> {result.studentDetails.universityRoll}</p>}
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: "30px", display: "flex", gap: "12px", justifyContent: "center" }}>
        <button 
          onClick={() => navigate("/student-login")}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            background: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Back to Login
        </button>
        <button 
          onClick={() => {
            // Allow student to check result again
            const activeTest = JSON.parse(localStorage.getItem("activeTest") || "{}");
            const studentSession = JSON.parse(localStorage.getItem("studentSession") || "{}");
            if (activeTest.specialStudentId || studentSession.specialStudentId) {
              navigate("/result");
            } else {
              navigate("/student-login");
            }
          }}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            background: "#22c55e",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Refresh Result
        </button>
      </div>
    </div>
  );
}
